



























































import Vue from 'vue'
import { Component, Emit, Prop, PropSync, VModel } from 'vue-property-decorator'

import Icon from '../../../../components/Icon/Icon.vue'
import { MenuDynamicHeader, MenuItemTypeEnum, MenuItems } from "../../NewConfig";
import routerExceptionHandler from '../../includes/RouterExceptionHandler'
import SidebarDropdown from './SidebarDropdown.vue'
import SidebarIcon from './SidebarIcon.vue'
import SidebarSingleItem from './SidebarSingleItem.vue'

@Component({
  components: {
    SidebarIcon,
    SidebarDropdown,
    SidebarSingleItem,
    Icon,
  },
})
export default class SidebarMenu extends Vue {
  @VModel() collapsed!: boolean

  @Prop() asideItems!: MenuItems

  @PropSync('activeDropdownGroup') activeGroup!: Array<string>

  @Emit('routeChange')
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  routeChange(): void {
  }

  handleDynamicHeaderClick(item: MenuDynamicHeader):void {
    if (item.type === MenuItemTypeEnum.DynamicHeader && item.route) {
      this.$router.push(item.route).catch(routerExceptionHandler)
    }
  }

  get activeKey(): Array<string> {
    if (this.$route.name) {
      return [ this.$route.name ]
    }

    return []
  }
}
